import UserProfileSvg from '@assets/images/svg/user-profile.svg';
import React from 'react';
import { View } from 'react-native';

export interface UserProfileIconProps {
  size?: number;
  color?: string;
}

/** Figma agent/profile silhouette for appointment confirmation details. */
export function UserProfileIcon({
  size = 14,
  color = '#4D4D4D',
}: Readonly<UserProfileIconProps>) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <UserProfileSvg width={size} height={size} color={color} />
    </View>
  );
}

export default UserProfileIcon;
